'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var zod = require('zod');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const SessionContext = /*#__PURE__*/React.createContext(null);
const useSession = () => {
  const context = React.useContext(SessionContext);
  if (!context) {
    throw new Error('No context provided for SessionContext provider');
  }
  return context;
};
const ClaimTypeOptionSchema = zod.z.union([zod.z.literal('ItemDamaged'), zod.z.literal('ItemMissing'), zod.z.literal('PackageMissing'), zod.z.literal('WrongItem')]);

// Validates the claim type is a valid ClaimTypeOption for submitting an eligibility lookup
function isClaimTypeOption(value) {
  return ClaimTypeOptionSchema.safeParse(value).success;
}
const SessionProvider = _ref => {
  let {
    children,
    value
  } = _ref;
  const [orderNumber, setOrderNumber] = React__default["default"].useState(value.orderNumber);
  // When we load the portal for the first time, we should attempt to auto-lookup order
  // After an initial lookup, set this to false to prevent further auto lookups
  const [attemptAutoLookup, setAttemptAutoLookup] = React__default["default"].useState(true);
  return /*#__PURE__*/React__default["default"].createElement(SessionContext.Provider, {
    value: {
      ...value,
      claimType: isClaimTypeOption(value.claimType) ? value.claimType : undefined,
      orderNumber,
      setOrderNumber,
      attemptAutoLookup,
      setAttemptAutoLookup,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
    }
  }, children);
};

exports.SessionContext = SessionContext;
exports.SessionProvider = SessionProvider;
exports.useSession = useSession;
